import BaseItem from '../../MyLeaves/RowItem';
import LeaveRules from '../../../LeaveRules';

export default class RowItem extends BaseItem {
    canBeCanceled(leave: any) {
        return LeaveRules.canBeCanceled(leave, (this.getSession().getState() as any).companyUser);
    }
}